import { format, parseISO } from 'date-fns';
import { getDayFromDate } from '@translations/functions';



interface OrderDatesProps {
	originalDeliveryDate: string | null;
	deliveryDate: string | null;
	smsWasSent: boolean;
	isRedated: boolean;
}


export const OrderDates = (props: OrderDatesProps) => {
	const { originalDeliveryDate, deliveryDate, smsWasSent, isRedated } = props;

	const parsedOriginalDeliveryDate = originalDeliveryDate ? parseISO(originalDeliveryDate) : null;
	const originalDeliveryDateDay = parsedOriginalDeliveryDate ? getDayFromDate(parsedOriginalDeliveryDate).toUpperCase() : null;
	const originalDeliveryDateResult = parsedOriginalDeliveryDate && originalDeliveryDateDay ? `${originalDeliveryDateDay} ${format(parsedOriginalDeliveryDate, 'd.M.')}` : '-';

	const parsedDeliveryDate = deliveryDate ? parseISO(deliveryDate) : null;
	const deliveryDateDay = parsedDeliveryDate ? getDayFromDate(parsedDeliveryDate).toUpperCase() : null;
	const deliveryDateResult = parsedDeliveryDate && deliveryDateDay ? `${deliveryDateDay} ${format(parsedDeliveryDate, 'd.M.')}` : '-';

	
	const getState = () => {
		if (parsedOriginalDeliveryDate && parsedDeliveryDate && !isRedated) return ' state-success';
		if (parsedOriginalDeliveryDate && parsedDeliveryDate && isRedated) return ' state-danger';
		return '';
	};

	
	return (
		<p className={`component-order-dates${getState()}`}>
				<span className={smsWasSent ? 'state-underscore' : ''}>
					{originalDeliveryDateResult}
				</span> / {deliveryDateResult}
		</p>
	)
}